export default __webpack_public_path__ + "static/media/Mobile-Dorada.3bdabb3d.svg";